export enum RecipeVisibilityType {
  Private = 'private',
  Team = 'team',
  Public = 'public',
  Organization = 'organization',
}
